import { AuthContext } from '@app/Context/AuthContext';
import { useContext } from 'react';

export const useAuthContext = () => useContext(AuthContext);
